<template>
  <voicemod-key-layout
    data-testid="layout"
    :variant="planType"
  >
    <div class="vm-key-order-success">
      <img
        class="vm-key-order-success__logo"
        src="./assets/keyLogo.svg"
        alt="vm key logo"
      >

      <h1 class="headline-lg">
        {{ $t('vmKeyOrderSuccess.title') }}
      </h1>
      <div class="vm-key-order-success__subtitle-container">
        <span class="vm-key-order-success__subtitle headline-sm">
          {{ $t('vmKeyOrderSuccess.subtitle.shipping') }}
        </span>
        <span class="vm-key-order-success__info body-sm">
          {{ $t('vmKeyOrderSuccess.info.tracking') }}
        </span>
        <hr
          v-if="this.planType === 'free'"
          class="vm-key-order-success__divider"
        >
        <span
          v-if="this.planType === 'free'"
          class="vm-key-order-success__subtitle headline-sm"
        >
          {{ $t('vmKeyOrderSuccess.subtitle.waiting') }}
        </span>
        <span
          v-if="this.planType === 'free'"
          class="vm-key-order-success__info body-sm"
        >
          {{ $t('vmKeyOrderSuccess.info.soundboard') }}
        </span>
      </div>
      <a
        href="https://account.voicemod.net/#/voicemod-soundboard-app"
        target="_blank"
      >
        <base-button
          :customizable="{ maxWidth: '350px' }"
          :is-type="['simple', 'vanish']"
          @click.native="handleGetVoicemodKey"
        >
          {{ $t('vmKeyOrderSuccess.button.download') }}
        </base-button>
      </a>
      <span class="vm-key-order-success__info body-sm">
        {{ $t('vmKeyOrderSuccess.info.help') }}
        <a
          href="https://www.voicemod.net/support/"
          class="interactive-sm"
        >{{ $t('vmKeyOrderSuccess.info.contact') }}</a>
      </span>

      <img
        class="vm-key-order-success__product"
        src="./assets/product.png"
        alt="vm key product"
      >
    </div>
  </voicemod-key-layout>
</template>

<script>
import VoicemodKeyLayout from '@/layouts/VoicemodKeyLayout.vue';
import BaseButton from '@RepoComponent/BaseButton/BaseButton';
import { metricsService } from '@/metrics/metrics';
import { mParticleMetric } from '@/metrics/mparticle';
import { WebSocketClient } from '@/services/websocket-client';

export default {
    name: 'VMKeyOrderSuccess',
    components: {
        VoicemodKeyLayout,
        BaseButton,
    },
    data() {
        return {
            sessionUserInfo: {},
        };
    },
    computed: {
        planType() {
            return this.sessionUserInfo?.subscription?.subscriptionType || 'free';
        },
    },
    async mounted() {
        this.sessionUserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        this.trackViewVMKeyOrderSuccess();

        // call to websocket to track purchase
        this.$store.dispatch('websocket_store/axn_websocketActionID', 'purchaseCheckoutOk');
        if (window.dataLayer) {
            window.dataLayer.push({event: 'checkoutCompleted'});
        }

        try {
            if (this.$route.query.client === 'flagship') {
                window.location.assign('voicemod:purchase_completed');
            }

            await WebSocketClient.connect({
                server: 'Kestrel',
                url: 'vmsd',
                actionType: 'purchaseCheckoutResponseOk',
            });
        } catch {
            console.log('Failed to open websocket connection');
        }
    },
    methods: {
        trackViewVMKeyOrderSuccess() {
            const eventData = {
                product_name: this.planType === 'free' ? 'vm-key-free' : 'vm-key-pro',
                product_id: this.$route.query.productId,
                original_voicemod_system: 'vm-mobile',
                page_url_full_path: window.location.hash.slice(1),
            };
            metricsService.trackEvent(eventData);
            mParticleMetric.track(
                mParticleMetric.EVENTS.WEB_CLICK_VM_KEY_START_CHECKOUT,
                {
                    page_url_full_path: eventData.page_url_full_path,
                },
                mParticleMetric.EVENT_TYPE.Navigation,
            );
        },
        trackGetVoicemodKey() {
            const eventData = {
                web_button_name: 'vmkey-download-mobile-app',
                original_voicemod_system: 'vm-mobile',
                page_url_full_path: window.location.hash.slice(1),
            };
            metricsService.trackEvent(eventData);
            mParticleMetric.track(
                mParticleMetric.EVENTS.WEB_CLICK,
                eventData,
                mParticleMetric.EVENT_TYPE.Transaction,
            );
        },
        handleGetVoicemodKey() {
            this.trackGetVoicemodKey();
        },
    },
};
</script>

<style src="./VMKeyOrderSuccess.scss" lang="scss" scoped></style>
